export default __webpack_public_path__ + "static/media/Gabriola.88ea98ef.ttf";